import { COOKIES_SESSION, COOKIES_CUSTOMER_ID, getCookies } from "./Cookies";
import { ERR_NO_CONNECTION, ERR_INTERNAL_USER } from "../native/Error";

const PATH = process.env.REACT_APP_API_VICTORY;

export const APP_VERSION = process.env.VERSION;

function fetchWithTimeout(url, options, timeout) {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("no_connection")), timeout)
    ),
  ]);
}

export function onRequest(
  route,
  body,
  listener_success,
  listener_fail,
  CUSTOM_PATH
) {
  if (listener_fail === undefined) {
    listener_fail = null;
  }
  let customer_id = getCookies(COOKIES_CUSTOMER_ID);
  let customer_session = getCookies(COOKIES_SESSION);
  let m_path = null;
  if (CUSTOM_PATH === undefined) {
    CUSTOM_PATH = null;
  }
  if (CUSTOM_PATH === null) {
    // USE DEFAULT PATH
    m_path = PATH + route;
  } else {
    // USE CUSTOM PATH
    m_path = CUSTOM_PATH + route;
  }
  // FOR TESTING ON SPECIFIC USER ACCOUNT
  // customer_id = 'C100000322';
  // customer_session = 'ccaa1d42-8d33-3bcf-8f61-a87122275a5e';
  fetchWithTimeout(
    m_path,
    {
      method: "POST",
      headers: {
        retail: customer_id,
        session: customer_session,
        version: APP_VERSION,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    },
    30000
  )
    .then((response) => response.json())
    .then((result) => {
      if (result.code === 1) {
        listener_success(result);
      } else {
        if (listener_fail !== null) {
          listener_fail(result);
        }
      }
    })
    .catch((error) => {
      if (listener_fail !== null) {
        let res_error = {};
        if (error.message === "no_connection") {
          // Specific for network error only
          res_error.message =
            "Tidak ada respon dari server, silahkan cek koneksi anda terlebih dahulu!";
          res_error.result = { action: ERR_NO_CONNECTION, message: "Refresh" };
        } else {
          // Internal server error
          res_error.message = `Message = ${error.message}.`;
          res_error.result = {
            action: ERR_INTERNAL_USER,
            message: "Laporkan Error",
          };
        }
        listener_fail(res_error);
      }
    });
}

export function onRequestForm(route, form, listener_success, listener_fail) {
  if (listener_fail === undefined) {
    listener_fail = null;
  }
  let customer_id = getCookies(COOKIES_CUSTOMER_ID);
  let customer_session = getCookies(COOKIES_SESSION);
  fetchWithTimeout(
    PATH + route,
    {
      method: "POST",
      headers: {
        retail: customer_id,
        session: customer_session,
        version: APP_VERSION,
      },
      body: form,
    },
    30000
  )
    .then((response) => response.json())
    .then((result) => {
      if (result.code === 1) {
        listener_success(result);
      } else {
        if (listener_fail !== null) {
          listener_fail(result);
        }
      }
    })
    .catch((error) => {
      if (listener_fail !== null) {
        let res_error = {};
        if (error.message === "no_connection") {
          // Specific for network error only
          res_error.message =
            "Tidak ada respon dari server, silahkan cek koneksi anda terlebih dahulu!";
          res_error.result = { action: ERR_NO_CONNECTION, message: "Refresh" };
        } else {
          // Internal server error
          res_error.message = `Message = ${error.message}.`;
          res_error.result = {
            action: ERR_INTERNAL_USER,
            message: "Laporkan Error",
          };
        }
        listener_fail(res_error);
      }
    });
}

export function onRequestGet(route, payload, listener_success, listener_fail) {
  if (listener_fail === undefined) {
    listener_fail = null;
  }

  let queryParams = "";
  
  for (const property in payload) {
    if(queryParams.length > 0) queryParams += '&';
    queryParams +=`${property}=${payload[property]}`;
  }

  let customer_id = getCookies(COOKIES_CUSTOMER_ID);
  let customer_session = getCookies(COOKIES_SESSION);
  fetchWithTimeout(
    PATH + route + "?" + queryParams,
    {
      method: "GET",
      headers: {
        retail: customer_id,
        session: customer_session,
        version: APP_VERSION,
      },
    },
    30000
  )
    .then((response) => response.json())
    .then((result) => {
      if (result.code === 1) {
        listener_success(result);
      } else {
        if (listener_fail !== null) {
          listener_fail(result);
        }
      }
    })
    .catch((error) => {
      if (listener_fail !== null) {
        let res_error = {};
        if (error.message === "no_connection") {
          // Specific for network error only
          res_error.message =
            "Tidak ada respon dari server, silahkan cek koneksi anda terlebih dahulu!";
          res_error.result = { action: ERR_NO_CONNECTION, message: "Refresh" };
        } else {
          // Internal server error
          res_error.message = `Message = ${error.message}.`;
          res_error.result = {
            action: ERR_INTERNAL_USER,
            message: "Laporkan Error",
          };
        }
        listener_fail(res_error);
      }
    });
}

/**
 * Fungsi request dinamis
 * @param {string} route - endpoint route
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE, dll)
 * @param {object} headers - custom headers (optional)
 * @param {any} body - payload/body (optional)
 * @param {function} listener_success - callback sukses
 * @param {function} listener_fail - callback gagal
 * @param {string} customPath - custom base path (optional)
 * @param {number} timeout - timeout ms (optional, default 30000)
 */
export function onRequestDynamic({
  route,
  method = "GET",
  headers = {},
  body = null,
  listener_success,
  listener_fail,
  customPath = null,
  timeout = 30000,
}) {
  if (listener_fail === undefined) listener_fail = null;
  let m_path = customPath ? customPath + route : PATH + route;

  let fetchOptions = {
    method,
    headers: headers,
  };

  if (body !== null && method !== "GET") {
    fetchOptions.body = typeof body === "object" ? JSON.stringify(body) : body;
    if (!headers["Content-Type"]) {
      fetchOptions.headers["Content-Type"] = "application/json";
    }
  }

  fetchWithTimeout(m_path, fetchOptions, timeout)
    .then(async (response) => {
      let result = null;

      try {
        result = await response.json();
      } catch (e) {
        result = null;
      }

      // ✅ HANDLE ERROR BERDASARKAN STATUS CODE
      if (!response.ok) {
        let message = "Terjadi kesalahan pada sistem.";

        switch (response.status) {
          case 400:
            message = "Permintaan tidak valid. Silakan periksa kembali data yang dikirim.";
            break;
          case 401:
            message = "Sesi kamu sudah habis. Silakan login ulang.";
            break;
          case 403:
            message = "Kamu tidak memiliki akses untuk melakukan aksi ini.";
            break;
          case 404:
            message = result?.message || "Data atau endpoint tidak ditemukan.";
            break;
          case 408:
            message = "Permintaan terlalu lama. Silakan coba lagi.";
            break;
          case 422:
            message = "Data yang dikirim tidak sesuai format yang diminta.";
            break;
          case 500:
            message = "Terjadi kesalahan pada server. Silakan coba lagi nanti.";
            break;
          case 503:
            message = "Server sedang sibuk. Silakan coba beberapa saat lagi.";
            break;
          default:
            message = `Terjadi kesalahan (${response.status}). Silakan coba lagi.`;
            break;
        }

        if (listener_fail) {
          listener_fail({
            message,
            status: response.status,
            result: result,
          });
        }

        return;
      }

      // ✅ SUKSES
      console.log("Request Result:", result);
      listener_success(result);
    })
    .catch((error) => {
      if (listener_fail !== null) {
        let res_error = {};

        if (error.message === "no_connection") {
          res_error.message =
            "Tidak ada respon dari server. Silakan cek koneksi internet kamu terlebih dahulu.";
          res_error.result = { action: ERR_NO_CONNECTION, message: "Refresh" };
        } else {
          res_error.message = "Terjadi kesalahan pada aplikasi. Silakan coba lagi.";
          res_error.result = {
            action: ERR_INTERNAL_USER,
            message: "Laporkan Error",
          };
        }

        listener_fail(res_error);
      }
    });
}
